import React, { FunctionComponent, InputHTMLAttributes } from "react";
import styled from "styled-components";
import { colours } from "../../styles/colours";
import { WIDGET_BORDER_RADIUS } from "../widget";

export type ITabsProps = InputHTMLAttributes<HTMLDivElement> & {
  tabs: Array<{
    title: React.ReactNode;
    content: React.ReactNode;
  }>;
  noMargin?: boolean;
  initialTab?: number;
};

const TabTitles = styled.div<{ noMargin: boolean }>`
  display: flex;
  justify-content: space-around;
  background: ${colours.lightestBlue};
  border-radius: ${WIDGET_BORDER_RADIUS};
  ${(props) => (props.noMargin ? "" : "margin-bottom: 2em")};
`;

const TabTitle = styled.div<{ isActive: boolean }>`
  font-weight: 700;
  color: ${(props) => (props.isActive ? colours.black : colours.darkGrey)};
  border-bottom: ${(props) =>
    props.isActive ? "2px solid " + colours.darkGrey : ""};
  padding: 1em;
  flex-grow: 1;
  text-align: center;
  border-top-right-radius: ${WIDGET_BORDER_RADIUS};
  border-top-left-radius: ${WIDGET_BORDER_RADIUS};
  cursor: pointer;
`;

export const Tabs: FunctionComponent<ITabsProps> = ({
  tabs,
  noMargin = false,
  initialTab = 0,
  ...props
}) => {
  const [tabIndex, setTabIndex] = React.useState(initialTab);
  return (
    <div {...props}>
      <TabTitles noMargin={noMargin}>
        {tabs.map(({ title }, index) => (
          <TabTitle
            key={index}
            isActive={index === tabIndex}
            onClick={() => setTabIndex(index)}
          >
            {title}
          </TabTitle>
        ))}
      </TabTitles>
      <div>{tabs[tabIndex]?.content || null}</div>
    </div>
  );
};
